import { Input } from "antd";
import styled from "styled-components";

export const FormInput = styled(Input)`
    border-radius: 4px;
    min-height: 50px;
    text-align: center;
`;